// Show & hide footer mobile accordion
const footerAcc = document.getElementsByClassName('footer-accordion');
const footerPanel = document.getElementsByClassName('footer-panel');

for (let i = 0; i < footerAcc.length; i++) {
  footerAcc[i].onclick = function () {
    let setClasses = !this.classList.contains('active');
    setClass(footerAcc, 'active', 'remove');
    setClass(footerPanel, 'show', 'remove');

    if (setClasses) {
      this.classList.toggle('active');
      this.nextElementSibling.classList.toggle('show');
    }
  };
}
function setClass(els, className, fnName) {
  for (let i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
}

// Get EST date object
function changeTimeZone(date, timeZone) {
  if (typeof date === 'string') {
    return new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone,
      }),
    );
  }

  return new Date(
    date.toLocaleString('en-US', {
      timeZone,
    }),
  );
}

// Display live customer support section based on hours of availability
// Chat is available Monday-Friday, 8:30-12 and 1-5 (EST)
let estDate = changeTimeZone(new Date(), 'America/New_York');
let day = estDate.getDay();
let hours = estDate.getHours();
let minutes = estDate.getMinutes();

const chatAvailable = document.getElementById('chat-available');
const chatUnavailable = document.getElementById('chat-unavailable');

if (day > 0 && day < 6) {
  // between 8:30 - 12
  if (hours == 8 && minutes >= 30 || hours >= 9 && hours < 12) {
    chatAvailable.style.display = 'flex';
  // between 1 - 5
  } else if (hours >= 13 && hours < 16) {
    chatAvailable.style.display = 'flex';
  } else {
    chatUnavailable.style.display = 'flex';
  }
} else {
  chatUnavailable.style.display = 'flex';
}
